import React from "react";

interface CasaLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const CasaLogo = ({ width = 120, height = 49, className }: CasaLogoProps) => {
  return (
    <svg
      className={className}
      width={width || "120"}
      height={height || "49"}
      viewBox="0 0 120 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask
        id="mask0_783_8266"
        style={{maskType: "luminance"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width || "120"}
        height={height || "49"}
      >
        <path d="M119.039 0H0V49H119.039V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_783_8266)">
        <mask
          id="mask1_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x={height || "49"}
          y="14"
          width="30"
          height="16"
        >
          <path
            d="M49.3235 14.6264V14.7601C49.3083 16.6911 49.6728 18.6059 50.396 20.394C51.1191 22.1821 52.1865 23.8079 53.5365 25.1775C54.8866 26.5471 56.4924 27.6334 58.2612 28.3734C60.0301 29.1135 61.9268 29.4928 63.8419 29.4893C65.7569 29.4857 67.6523 29.0995 69.4185 28.353C71.1846 27.6064 72.7865 26.5143 74.1316 25.1397C75.4766 23.7652 76.5382 22.1354 77.2549 20.3447C77.9715 18.554 78.3291 16.6378 78.307 14.7069V14.5991L49.3235 14.6264Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_783_8266)">
          <path
            d="M80.9592 11.9523H46.6715V31.9313H80.9592V11.9523Z"
            fill="#F26E5F"
          />
        </g>
        <mask
          id="mask2_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="57"
          y="14"
          width="14"
          height="8"
        >
          <path
            d="M57.3323 14.6264C57.3254 14.6707 57.3254 14.7158 57.3323 14.7601C57.3393 16.4939 58.0291 18.154 59.2499 19.375C60.4707 20.596 62.1226 21.278 63.8421 21.271C65.5616 21.2639 67.2079 20.5684 68.4188 19.3374C69.6297 18.1064 70.3061 16.4407 70.2991 14.7069V14.5991L57.3323 14.6264Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_783_8266)">
          <path
            d="M72.9513 11.9523H54.6804V23.8568H72.9513V11.9523Z"
            fill="#FFC6BC"
          />
        </g>
        <mask
          id="mask3_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="15"
          height="30"
        >
          <path
            d="M0 14.8132C0.00716088 18.6828 1.53484 22.3919 4.24847 25.1282C6.96211 27.8645 10.6405 29.4049 14.4782 29.4121H14.7434V0.186951H14.4782C10.6358 0.194187 6.95332 1.73836 4.23891 4.48052C1.5245 7.22269 -6.70154e-06 10.9388 0 14.8132Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_783_8266)">
          <path
            d="M17.4225 -2.48724H-2.65222V32.0835H17.4225V-2.48724Z"
            fill="#F26E5F"
          />
        </g>
        <mask
          id="mask4_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="7"
          height="14"
        >
          <path
            d="M8.00888 14.813C8.01564 16.5413 8.69952 18.1969 9.91153 19.419C11.1235 20.6411 12.7654 21.3307 14.4794 21.3375H14.7446V8.26263H14.4794C12.761 8.26948 11.1152 8.96263 9.90249 10.1903C8.68976 11.418 8.00887 13.0802 8.00888 14.813Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_783_8266)">
          <path
            d="M17.4223 5.5885H5.35666V24.0118H17.4223V5.5885Z"
            fill="#FFC6BC"
          />
        </g>
        <mask
          id="mask5_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="18"
          y="0"
          width="30"
          height="30"
        >
          <path
            d="M18.9609 14.8133C18.9607 16.7306 19.3351 18.6291 20.0626 20.4005C20.7901 22.1719 21.8566 23.7814 23.201 25.1372C24.5454 26.493 26.1416 27.5685 27.8982 28.3023C29.6549 29.036 31.5377 29.4137 33.4391 29.4137L47.9971 29.4669C47.9971 29.4669 47.9173 18.343 47.9173 14.7874C47.9363 12.8563 47.5755 10.9405 46.8557 9.1508C46.136 7.36111 45.0715 5.73304 43.724 4.36069C42.3764 2.98834 40.7724 1.89893 39.0048 1.15546C37.2371 0.411978 35.3408 0.0291748 33.4256 0.0291748C31.5103 0.0291748 29.614 0.411978 27.8464 1.15546C26.0787 1.89893 24.4747 2.98834 23.1272 4.36069C21.7796 5.73304 20.7152 7.36111 19.9954 9.1508C19.2757 10.9405 18.9149 12.8563 18.9338 14.7874"
            fill="white"
          />
        </mask>
        <g mask="url(#mask5_783_8266)">
          <path
            d="M50.6762 -2.48584H16.3087V32.1525H50.6762V-2.48584Z"
            fill="#F26E5F"
          />
        </g>
        <mask
          id="mask6_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="26"
          y="8"
          width="14"
          height="14"
        >
          <path
            d="M26.9686 14.813C26.9686 16.1034 27.3481 17.3648 28.0591 18.4378C28.77 19.5107 29.7806 20.347 30.9629 20.8408C32.1453 21.3347 33.4463 21.4639 34.7015 21.2121C35.9566 20.9604 37.1096 20.339 38.0145 19.4265C38.9194 18.514 39.5357 17.3515 39.7853 16.0858C40.035 14.8202 39.9069 13.5083 39.4171 12.3161C38.9274 11.1239 38.098 10.105 37.034 9.38803C35.9699 8.67111 34.7189 8.28845 33.4391 8.28845C31.723 8.28845 30.0772 8.97586 28.8638 10.1994C27.6503 11.423 26.9686 13.0826 26.9686 14.813Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask6_783_8266)">
          <path
            d="M42.5873 5.5885H24.3163V24.009H42.5873V5.5885Z"
            fill="#FFC6BC"
          />
        </g>
        <mask
          id="mask7_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="56"
          y="-1"
          width="30"
          height="16"
        >
          <path
            d="M56.9615 14.4994V14.6331H85.9193V14.5454C85.9223 12.6263 85.5505 10.7255 84.8249 8.95136C84.0994 7.17724 83.0344 5.56459 81.6907 4.20548C78.9772 1.46064 75.2934 -0.0848232 71.4497 -0.0909243C69.5465 -0.0939452 67.6614 0.281048 65.9019 1.01264C64.1425 1.74424 62.5432 2.81811 61.1953 4.17295C58.4732 6.90916 56.9405 10.6237 56.9344 14.4994"
            fill="white"
          />
        </mask>
        <g mask="url(#mask7_783_8266)">
          <path
            d="M88.597 -2.67426H54.3094V17.2889H88.597V-2.67426Z"
            fill="#F26E5F"
          />
        </g>
        <mask
          id="mask8_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="64"
          y="8"
          width="14"
          height="7"
        >
          <path
            d="M64.9692 14.4924V14.6262H77.9103V14.5456C77.9137 12.8152 77.2353 11.1543 76.0242 9.92833C74.8132 8.70232 73.1687 8.01162 71.4526 8.00819C70.6029 8.00649 69.7611 8.17357 68.9754 8.49989C68.1897 8.82621 67.4755 9.30537 66.8735 9.91003C65.6576 11.1312 64.9726 12.7894 64.9692 14.5198"
            fill="white"
          />
        </mask>
        <g mask="url(#mask8_783_8266)">
          <path
            d="M80.588 5.40155H62.317V17.2918H80.588V5.40155Z"
            fill="#FFC6BC"
          />
        </g>
        <mask
          id="mask9_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="87"
          y="0"
          width="30"
          height="30"
        >
          <path
            d="M87.6148 14.813C87.6149 16.7324 87.9905 18.633 88.7198 20.4059C89.4492 22.1788 90.5181 23.7893 91.8653 25.1453C93.2126 26.5012 94.8118 27.576 96.5714 28.3081C98.331 29.0403 100.217 29.4154 102.12 29.412L116.678 29.4652C116.678 29.4652 116.598 18.3413 116.598 14.7857C116.617 12.8546 116.256 10.9388 115.537 9.14909C114.817 7.35941 113.752 5.73133 112.405 4.35898C111.057 2.98663 109.453 1.89722 107.686 1.15375C105.918 0.410269 104.022 0.0274658 102.107 0.0274658C100.191 0.0274658 98.295 0.410269 96.5273 1.15375C94.7596 1.89722 93.1557 2.98663 91.8081 4.35898C90.4605 5.73133 89.3961 7.35941 88.6763 9.14909C87.9566 10.9388 87.5958 12.8546 87.6148 14.7857"
            fill="white"
          />
        </mask>
        <g mask="url(#mask9_783_8266)">
          <path
            d="M119.33 -2.48584H84.9625V32.1525H119.33V-2.48584Z"
            fill="#F26E5F"
          />
        </g>
        <mask
          id="mask10_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="93"
          y="7"
          width="18"
          height="19"
        >
          <path
            d="M110.782 7.28369H93.1971V25.0155H110.782V7.28369Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask10_783_8266)">
          <rect
            x="93.1971"
            y="7.28369"
            width="17.5851"
            height="17.7318"
            fill="url(#pattern0)"
          />
        </g>
        <mask
          id="mask11_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="95"
          y="8"
          width="14"
          height="14"
        >
          <path
            d="M95.6236 14.813C95.6236 16.1034 96.003 17.3648 96.714 18.4378C97.425 19.5107 98.4356 20.347 99.618 20.8408C100.8 21.3347 102.101 21.4639 103.356 21.2121C104.612 20.9604 105.765 20.339 106.67 19.4265C107.574 18.514 108.191 17.3515 108.44 16.0858C108.69 14.8202 108.562 13.5083 108.072 12.3161C107.582 11.1239 106.753 10.105 105.689 9.38803C104.625 8.67111 103.374 8.28845 102.094 8.28845C100.378 8.28845 98.7322 8.97586 97.5187 10.1994C96.3053 11.423 95.6236 13.0826 95.6236 14.813Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask11_783_8266)">
          <path
            d="M111.242 5.5885H92.9713V24.009H111.242V5.5885Z"
            fill="#FFC6BC"
          />
        </g>
        <mask
          id="mask12_783_8266"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width || "120"}
          height={height || "49"}
        >
          <path d="M119.039 0H0V49H119.039V0Z" fill="white" />
        </mask>
        <g mask="url(#mask12_783_8266)">
          <path
            d="M45.9823 37.7458C45.0664 37.7462 44.1723 38.028 43.4191 38.5535C42.6659 39.079 42.0893 39.8233 41.7661 40.6874H35.3754V20.8997H32.1928V43.8951H41.7661C42.0564 44.6712 42.5518 45.3524 43.1987 45.865C43.8455 46.3776 44.6191 46.7019 45.4356 46.8029C46.2521 46.9039 47.0805 46.7777 47.831 46.4379C48.5815 46.0982 49.2255 45.5579 49.6933 44.8755C50.1611 44.1931 50.4347 43.3947 50.4847 42.5667C50.5347 41.7387 50.3591 40.9127 49.9768 40.1782C49.5946 39.4436 49.0203 38.8285 48.3162 38.3995C47.6121 37.9705 46.805 37.7454 45.9823 37.7458ZM45.9823 44.161C45.6157 44.161 45.2573 44.0514 44.9525 43.846C44.6477 43.6407 44.4101 43.3488 44.2698 43.0072C44.1295 42.6657 44.0928 42.2899 44.1643 41.9273C44.2358 41.5648 44.4124 41.2317 44.6716 40.9703C44.9309 40.7089 45.2611 40.5309 45.6207 40.4588C45.9803 40.3867 46.353 40.4237 46.6917 40.5652C47.0304 40.7066 47.3199 40.9462 47.5236 41.2536C47.7272 41.5609 47.8359 41.9223 47.8359 42.292C47.8359 42.7877 47.6406 43.2631 47.293 43.6136C46.9454 43.9641 46.4739 44.161 45.9823 44.161Z"
            fill="#FFC6BC"
          />
          <path
            d="M100.635 20.724L100.635 36.8504C99.4225 37.212 98.3845 37.9833 97.7092 39.0239C97.034 40.0646 96.7663 41.3056 96.9549 42.5214C97.1435 43.7372 97.7758 44.8471 98.7369 45.6492C99.6981 46.4513 100.924 46.8925 102.192 46.8925C103.46 46.8925 104.687 46.4513 105.648 45.6492C106.609 44.8471 107.241 43.7372 107.43 42.5214C107.618 41.3056 107.351 40.0646 106.675 39.0239C106 37.9833 104.962 37.212 103.75 36.8504L103.75 20.724L102.192 20.724L100.635 20.724ZM104.373 41.743C104.373 42.1605 104.245 42.5687 104.006 42.9159C103.767 43.263 103.427 43.5336 103.029 43.6933C102.631 43.8531 102.193 43.8949 101.771 43.8135C101.348 43.732 100.96 43.531 100.656 43.2357C100.351 42.9405 100.144 42.5644 100.06 42.1549C99.976 41.7454 100.019 41.3209 100.184 40.9352C100.349 40.5495 100.628 40.2198 100.986 39.9878C101.344 39.7558 101.765 39.632 102.196 39.632C102.482 39.632 102.765 39.6867 103.029 39.7928C103.293 39.8988 103.533 40.0543 103.735 40.2503C103.938 40.4464 104.098 40.6791 104.207 40.9352C104.317 41.1913 104.373 41.4658 104.373 41.743Z"
            fill="#FFC6BC"
          />
        </g>
      </g>
      <path
        d="M60.6645 45.8889H57.2143V35.707H60.7341C61.745 35.707 62.6134 35.9109 63.3393 36.3185C64.0684 36.7229 64.6286 37.3046 65.0197 38.0636C65.4107 38.8226 65.6063 39.7307 65.6063 40.788C65.6063 41.8486 65.4091 42.7601 65.0147 43.5224C64.6236 44.2847 64.0585 44.8697 63.3194 45.2773C62.5836 45.685 61.6986 45.8889 60.6645 45.8889ZM59.0587 44.293H60.575C61.2843 44.293 61.8759 44.1637 62.3499 43.9052C62.8239 43.6434 63.1802 43.2539 63.4188 42.7369C63.6574 42.2165 63.7768 41.5669 63.7768 40.788C63.7768 40.0091 63.6574 39.3628 63.4188 38.8491C63.1802 38.332 62.8272 37.9459 62.3598 37.6907C61.8958 37.4322 61.3191 37.3029 60.6297 37.3029H59.0587V44.293ZM70.6102 46.038C69.8645 46.038 69.2182 45.8739 68.6713 45.5458C68.1244 45.2177 67.7002 44.7586 67.3986 44.1687C67.1003 43.5787 66.9511 42.8893 66.9511 42.1005C66.9511 41.3117 67.1003 40.6206 67.3986 40.0273C67.7002 39.4341 68.1244 38.9734 68.6713 38.6452C69.2182 38.3171 69.8645 38.1531 70.6102 38.1531C71.3559 38.1531 72.0022 38.3171 72.5491 38.6452C73.096 38.9734 73.5186 39.4341 73.8169 40.0273C74.1185 40.6206 74.2693 41.3117 74.2693 42.1005C74.2693 42.8893 74.1185 43.5787 73.8169 44.1687C73.5186 44.7586 73.096 45.2177 72.5491 45.5458C72.0022 45.8739 71.3559 46.038 70.6102 46.038ZM70.6201 44.5962C71.0245 44.5962 71.3626 44.4852 71.6344 44.2631C71.9061 44.0378 72.1083 43.7362 72.2409 43.3583C72.3768 42.9805 72.4447 42.5595 72.4447 42.0955C72.4447 41.6282 72.3768 41.2056 72.2409 40.8278C72.1083 40.4466 71.9061 40.1434 71.6344 39.918C71.3626 39.6926 71.0245 39.5799 70.6201 39.5799C70.2058 39.5799 69.8612 39.6926 69.5861 39.918C69.3143 40.1434 69.1104 40.4466 68.9746 40.8278C68.842 41.2056 68.7757 41.6282 68.7757 42.0955C68.7757 42.5595 68.842 42.9805 68.9746 43.3583C69.1104 43.7362 69.3143 44.0378 69.5861 44.2631C69.8612 44.4852 70.2058 44.5962 70.6201 44.5962ZM79.1278 46.038C78.3655 46.038 77.7109 45.8706 77.164 45.5359C76.6204 45.2011 76.2012 44.7388 75.9062 44.1488C75.6145 43.5555 75.4687 42.8728 75.4687 42.1005C75.4687 41.3249 75.6178 40.6405 75.9161 40.0472C76.2144 39.4506 76.6354 38.9866 77.1789 38.6552C77.7258 38.3204 78.3721 38.1531 79.1178 38.1531C79.7376 38.1531 80.2862 38.2674 80.7634 38.4961C81.244 38.7215 81.6268 39.0413 81.9119 39.4556C82.1969 39.8666 82.3593 40.3472 82.3991 40.8974H80.6789C80.6093 40.5295 80.4436 40.2229 80.1818 39.9776C79.9232 39.7291 79.5769 39.6048 79.1427 39.6048C78.7748 39.6048 78.4516 39.7042 78.1732 39.9031C77.8948 40.0986 77.6777 40.3803 77.522 40.7482C77.3695 41.1161 77.2933 41.5569 77.2933 42.0707C77.2933 42.591 77.3695 43.0385 77.522 43.413C77.6744 43.7842 77.8882 44.0709 78.1633 44.2731C78.4417 44.472 78.7682 44.5714 79.1427 44.5714C79.4078 44.5714 79.6448 44.5217 79.8536 44.4222C80.0658 44.3195 80.2431 44.172 80.3856 43.9798C80.5281 43.7875 80.6259 43.5539 80.6789 43.2788H82.3991C82.356 43.819 82.1969 44.2979 81.9218 44.7156C81.6467 45.1299 81.2722 45.4547 80.7982 45.69C80.3243 45.922 79.7675 46.038 79.1278 46.038ZM89.9124 40.271L88.2718 40.4499C88.2254 40.2842 88.1442 40.1284 88.0282 39.9826C87.9155 39.8368 87.763 39.7191 87.5708 39.6296C87.3785 39.5401 87.1432 39.4954 86.8648 39.4954C86.4903 39.4954 86.1754 39.5766 85.9202 39.739C85.6683 39.9014 85.544 40.1119 85.5473 40.3704C85.544 40.5925 85.6252 40.7731 85.791 40.9123C85.96 41.0515 86.2384 41.1658 86.6262 41.2553L87.9287 41.5337C88.6513 41.6895 89.1882 41.9364 89.5395 42.2745C89.8942 42.6126 90.0732 43.055 90.0765 43.6019C90.0732 44.0825 89.9323 44.5068 89.6539 44.8747C89.3788 45.2392 88.996 45.5243 88.5054 45.7298C88.0149 45.9353 87.4515 46.038 86.8151 46.038C85.8804 46.038 85.1281 45.8425 84.558 45.4514C83.9879 45.0569 83.6482 44.5084 83.5388 43.8058L85.2938 43.6367C85.3733 43.9814 85.5424 44.2416 85.8009 44.4173C86.0594 44.5929 86.3958 44.6808 86.8101 44.6808C87.2377 44.6808 87.5807 44.5929 87.8392 44.4173C88.1011 44.2416 88.232 44.0245 88.232 43.766C88.232 43.5472 88.1475 43.3666 87.9785 43.2241C87.8127 43.0816 87.5542 42.9722 87.2029 42.896L85.9003 42.6225C85.1678 42.4701 84.6259 42.2132 84.2746 41.8519C83.9233 41.4873 83.7493 41.0266 83.7526 40.4698C83.7493 39.9992 83.8769 39.5915 84.1354 39.2468C84.3973 38.8988 84.7602 38.6303 85.2242 38.4414C85.6915 38.2492 86.2301 38.1531 86.84 38.1531C87.7348 38.1531 88.4392 38.3436 88.9529 38.7248C89.4699 39.1059 89.7898 39.6213 89.9124 40.271Z"
        fill="#333333"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_783_8266" transform="scale(0.0294118)" />
        </pattern>
        <image
          id="image0_783_8266"
          width="34"
          height="34"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAWJAAAFiQFtaJ36AAAC8UlEQVRYR7WY23biMAxFtynQ29z+/y9npqVAIZ4H6yTHxuHSdrSWVgIh8s6xLCuknDO3WEoptV8BVZB8a1AgXXOPDZ46LssdvxrqLIgBLCiDLoC7OMplA2XwY5wf4/MAl4GWcxcCwge/A1bhy/AW5Ai8hx/Cj8CQUjoLc6JIo8KCMuAauDdfU4Du7FaH2IVv7buBM+rMKSIVVpSBn4BHOzqIknVggtgCm/jNW8TbR+yBjlUgoYYg1pRBn4Fv4Q6iqXGQIxPII+UhVsBL/G4X4wytKiNIkxOC+Ab8CBfIfdynpJUJ5CFcEFJNwDsgtznjighC0/FMAfgVR0EouEPIBKOk1u9ctcHOaxBTQ3nxCHwHfjKp8RDX2mXrpmsOIIiD+QC8p5SSVHFFtEIeqPPimQlCMp8zB4Cptryba1mPhW9pCerT8mTezvU15tMsNfaUJN5S8uRAqS8p55xdYk2Lks2zXk95iwlGKp+NubCjQNZxky/RuZy4ZIq7pC6IJwr7fIp+ZT63Om4xLQKP7TUowTRIb19pk+6jNhe7OzXtDYmvgXDzmCcP2ZO96ie+0DxmexxBvOqpn/gqII/j8avNb9H86MBpBfwsCNSxVdAqmFYRFZ4ddR/xURhVVQHsmamsDqIyrG1cTc1nlPGH21J6E8UVCADLnHNOKTmImpq271hx2ypqITbhAhmA3G56mhopsmGqgEsmAC9Ecya5NRVvlMbohRJX014r0gRQh7XhtPnJTE2RwyTq5ehKbIC/5gI52D1AgMT0YEG29JuaA6cwut5CvAGvwB/gN0WR7rSAKRIwCuRVz/PHe9Ye6JE6J14oSvi0HIH5ntUsU2B03iadtnJNnUC0TL2Lfw2vehA6VoF0pqgntxrjFsST3UvALu4dK3bvvab7yjnzkqVepbeVO7AK4d4+j1tGDwJmQMaL9SuGb+PyNln11Ac7n1XB7eK/AZ1/As61CXryUQHg4gs4XAHi1kD5EepaUk5uCH4TyP+0f/OeqETk05hXAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};

export default CasaLogo;
